export type LayoutKey = "story" | "avatar" | "cast";

export type Rect = { x: number; y: number; width: number; height: number };
export type Transform = { zoom: number; panX: number; panY: number };

export function coverGeometry(
  imageWidth: number,
  imageHeight: number,
  rect: Rect,
  transform: Transform,
) {
  const baseScale = Math.max(rect.width / imageWidth, rect.height / imageHeight);
  const width = imageWidth * baseScale * transform.zoom;
  const height = imageHeight * baseScale * transform.zoom;
  const maxX = Math.max(0, (width - rect.width) / 2);
  const maxY = Math.max(0, (height - rect.height) / 2);
  const panX = Math.min(maxX, Math.max(-maxX, transform.panX));
  const panY = Math.min(maxY, Math.max(-maxY, transform.panY));

  return {
    x: rect.x + (rect.width - width) / 2 + panX,
    y: rect.y + (rect.height - height) / 2 + panY,
    width,
    height,
    panX,
    panY,
  };
}
